import { get } from 'lodash';

export const parseUserDetails = ( rawDetails ) => {
  return {
    accountCountry: get(rawDetails, 'countryCode', 'US'),
    // Notice we drop the -Name suffix below
    unitsOfMeasureTemplate: get(rawDetails, 'preferences.unitsOfMeasureTemplateName', 'imperial'),
    roles: get(rawDetails, 'roles', []),
    currency: get(rawDetails, 'preferences.currency', 'USD'),
    uuid: get(rawDetails, 'uuid'),
    email: get(rawDetails, 'email'),
    // Not all users have domain or username arrays
    ...(rawDetails.domain && { domain: rawDetails.domain }),
    ...(rawDetails.username && { username: rawDetails.username }),
  };
};
